import { useState } from "react";
import { authApi, LOGO_MARK } from "../lib/api";
import { toast } from "sonner";

export default function LoginPage({ t, onSuccess, onBack }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await authApi.login(username.trim(), password);
      localStorage.setItem("amatour_token", data.token);
      onSuccess(data.user);
    } catch (err) {
      toast.error(err.response?.data?.detail || t.login.wrong);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="amatour-shell grain" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px", position: "relative" }}>
      <div className="tribe-flag" style={{ position: "absolute", top: 0, left: 0, right: 0 }} />
      <form onSubmit={submit} className="card-amatour card-corners fade-in relative" style={{ padding: "48px", width: "100%", maxWidth: "440px", zIndex: 5 }} data-testid="login-form">
        <div className="text-center mb-10">
          <img src={LOGO_MARK} alt="Amatour" style={{ height: 92, margin: "0 auto 20px", filter: "drop-shadow(0 8px 24px rgba(212,175,55,0.35))" }} />
          <div className="section-eyebrow" style={{ justifyContent: "center", display: "flex" }}>Espace privé</div>
          <h1 className="font-display text-4xl mt-1 gold-accent">Amatour Festival</h1>
          <p className="italic-accent text-sm mt-3 opacity-80">{t.login.subtitle}</p>
        </div>
        <div className="space-y-5">
          <div>
            <label className="label-amatour">{t.login.user}</label>
            <input className="input-amatour" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus data-testid="login-username" />
          </div>
          <div>
            <label className="label-amatour">{t.login.pass}</label>
            <input type="password" className="input-amatour" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <div className="pt-2">
            <button type="submit" className="btn-gold w-full" disabled={busy} data-testid="login-submit">
              {busy ? <><i className="fa-solid fa-spinner spin" /> …</> : <><i className="fa-solid fa-lock-open" /> &nbsp;{t.login.submit}</>}
            </button>
          </div>
          <button type="button" className="btn-ghost w-full" onClick={onBack} data-testid="login-back">
            <i className="fa-solid fa-arrow-left" /> &nbsp;Retour au site
          </button>
        </div>
      </form>
    </div>
  );
}
